import {useHierarchyNavAccess} from '@domain/kpis'
import {PermissionType} from '@hconnect/apiclient'
import {Loader} from '@hconnect/uikit/src/lib2'
import {SUPPORTED_MAP_AREAS} from '@widgets/area-dashboard'
import {Navigate} from 'react-router'

import {HierarchyRouteSegment} from '../../routing'

type Props = {
  permission: PermissionType
}

export const HierarchyLocationAccessRedirect = ({permission}: Props) => {
  const {isInitialLoading, allowedAreas, getPlantsByAreaId} = useHierarchyNavAccess(permission)
  if (isInitialLoading) {
    return <Loader />
  }

  if (allowedAreas.length === 1) {
    const accessibleArea = allowedAreas[0]
    const accessibleAreaPlants = getPlantsByAreaId(accessibleArea)

    if (accessibleAreaPlants.length === 1) {
      return (
        <Navigate
          to={`${HierarchyRouteSegment.AREA}/${accessibleArea}/${HierarchyRouteSegment.PLANT}/${accessibleAreaPlants[0].id}`}
        />
      )
    }

    if (accessibleAreaPlants.length > 1) {
      if (SUPPORTED_MAP_AREAS.includes(accessibleArea)) {
        return <Navigate to={`${HierarchyRouteSegment.AREA}/${accessibleArea}`} />
      }

      return <Navigate to={HierarchyRouteSegment.PLANT} />
    }
  }

  if (allowedAreas.length > 1) {
    return <Navigate to={HierarchyRouteSegment.AREA} />
  }

  // User does not have access to any location
  return <Navigate to="/" />
}
